// extracted by mini-css-extract-plugin
export default {"icon":"benefits_icon__xpZpu","card":"benefits_card__DTmN7","transparent":"benefits_transparent__9C8FD","image":"benefits_image__uAQoi","Button":"benefits_Button__Wl8wv"};